export default "__VITE_ASSET__DLzAHhdC__"